// src/api/interceptors/authInterceptors.ts
import type { FetchOptions } from '@/types/api.types';
import { getSessionToken, getRegistrationToken } from '@/utils/sessionStorage';

export const authRequestInterceptor = (options: FetchOptions): FetchOptions => {
  const token = getSessionToken() ?? getRegistrationToken();
  const headers = { ...(options.headers ?? {}) };

  if (token !== null && token.trim() !== '') {
    headers.Authorization = `Bearer ${token}`;
  }

  return { ...options, headers };
};

export const authResponseInterceptor = (response: Response): Response => response;
